(() => {
  const types = {'Bulk Roll Pricing':'bulk','Wholesale Clearance Lot':'clearance','Distributor / Reseller Inquiry':'reseller'};
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const inquiry = root.querySelector('[data-inquiry-type]');
    if (!form || !inquiry) return;
    const delivery = root.querySelector('[data-delivery-method]');
    const params = new URLSearchParams(window.location.search);
    const clean = (name, limit = 300) => (params.get(name) || '').trim().slice(0, limit);
    const set = (selector, value) => { const input = root.querySelector(selector); if (input && !input.value && value) input.value = value; };
    const country = root.querySelector('[name="contact[Delivery Country]"]');
    if (country && !country.value) country.value = 'United States';
    if (country && country.value === '---') country.value = 'United States';
    if (clean('inquiry') === 'reseller') inquiry.value = 'Distributor / Reseller Inquiry';
    else if (clean('inquiry') === 'bulk') inquiry.value = 'Bulk Roll Pricing';
    else if (clean('inquiry') === 'clearance' || clean('product') || clean('lot_id')) inquiry.value = 'Wholesale Clearance Lot';
    set('[data-lot-product]', clean('product_title') || clean('product'));
    set('[data-lot-sku]', clean('sku', 150));
    set('[data-lot-id]', clean('lot_id', 150));
    set('[data-source-product]', clean('product'));
    function show(container, active) {
      container.hidden = !active;
      container.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !active;
        if (input.hasAttribute('data-panel-required')) input.required = active;
      });
    }
    function update() {
      const type = types[inquiry.value];
      root.querySelectorAll('[data-inquiry-panel]').forEach(panel => show(panel, panel.dataset.inquiryPanel === type));
      const shipping = delivery.value !== 'Arrange pickup';
      show(root.querySelector('[data-destination]'), shipping);
      show(root.querySelector('[data-freight-details]'), type === 'clearance' && delivery.value === 'Delivery quote needed');
    }
    inquiry.addEventListener('change', update);
    delivery.addEventListener('change', update);
    // Never add a second submission handler: Shopify owns validation, CAPTCHA and delivery.
    update();
  }
  const start = () => document.querySelectorAll('[data-wholesale-inquiry]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
